<template>
    <view-card-row :heading="'선택한 스타일'" :sm="12">
        <v-col>
            <v-row>
                <v-col cols="12" sm="6" class="py-0 d-flex justify-center align-center" style="cursor:pointer;" @click="$emit('show-overlay', portfolio.image)">
                    <v-img max-width="100%" max-height="100%" :src="portfolio.thumb" />
                </v-col>
                <view-card-column>
                    <v-row class="py-0 text-subtitle-1">{{ portfolio.subject }}</v-row>
                    <v-row class="py-0 text-subtitle-2">{{ portfolio.category.name }} · {{ portfolio.construction.acreage }} · {{ portfolio.user.meta.companyName }}</v-row>
                    <v-row class="py-0">
                        <v-btn large text color="primary" class="pa-0" @click="goDetail">자세히 보기 ></v-btn>
                    </v-row>
                </view-card-column>
            </v-row>
        </v-col>
    </view-card-row>
</template>
<script>
import ViewCardColumn from "../dumb/view-card-column.vue";
import viewCardRow from "../dumb/view-card-row.vue";
export default {
    components: { viewCardRow, ViewCardColumn },
    props: {
        portfolio: Object,
    },
    methods: {
        goDetail(event) {
            event.preventDefault();
            let route = this.$router.resolve({ path: this.detailPath });
            window.open(route.href, "_blank");
        },
    },
    computed: {
        detailPath() {
            let path = "/portfolio/";

            const parent = this.portfolio?.category?._parents[0];
            switch (parent) {
                case "5fae46e6dc19c41f74a85f04":
                    path += "resident";
                    break;
                case "5fae50b7dc19c41f74a85f05":
                    path += "industry";
                    break;
                case "5fae50c7dc19c41f74a85f06":
                    path += "partial";
                    break;
                default:
                    path += "resident";
            }
            path += "/";
            path += this.portfolio?._id;

            return path;
        },
    },
};
</script>
